import React, {PropTypes} from 'react';

const LoginOMBMessage = ({form, secondForm}) => {
  let ombControlNumber = '';
  let ombControlNumber2 = '';
  let ombExpirationDate = '';
  let ombExpirationDate2 = '';
  let ombFormNumber = '';
  let ombFormNumber2 = '';
  let message = [];
  let message2 = [];
  if(form){
    if(form.formQuestions){
      form.formQuestions.forEach(question =>{
        if(question.questionId=='ombControlNumber'){
          ombControlNumber = question.questionName;
        }else if(question.questionId=='ombExpirationDate'){
          ombExpirationDate = question.questionName;
        }else if(question.questionId=='ombFormNumber'){
          ombFormNumber = question.questionName;
        }
      });
      message.push(
        <div className="omb-message-box col-xs-12"
          dangerouslySetInnerHTML={{__html: form.formPageHelp}}
        />
      );
    }
  }

  if(secondForm){
    if(secondForm.formQuestions){
      secondForm.formQuestions.forEach(question =>{
        if(question.questionId=='ombControlNumber'){
          ombControlNumber = question.questionName;
        }else if(question.questionId=='ombExpirationDate'){
          ombExpirationDate = question.questionName;
        }else if(question.questionId=='ombFormNumber'){
          ombFormNumber = question.questionName;
        }
      });
      message2.push(
        <div className="omb-message-box col-xs-12"
          dangerouslySetInnerHTML={{__html: form.formPageHelp}}
        />
      );
    }
  }
  

  return (
    <div className="omb-message-page">
      <div className="omb-message">
        <div className="omb-header omb-header-left col-md-6 col-sm-6 col-xs-12">
          {ombControlNumber}
        </div>
        <div className="omb-header omb-header-right col-md-6 col-sm-6 col-xs-12">
          {ombExpirationDate}
        </div>
        {message[0]}
      </div>
      <div className="omb-message">
        <div className="omb-header omb-header-left col-md-6 col-sm-6 col-xs-12">
          {ombControlNumber2}
        </div>
        <div className="omb-header omb-header-right col-md-6 col-sm-6 col-xs-12">
          {ombExpirationDate2}
        </div>
        {message2[0]}
      </div>
      <div className="osha-form-number">
          {ombFormNumber && ombFormNumber2 ? ombFormNumber : null}
      </div>
    </div>
  );
};

LoginOMBMessage.propTypes = {
  form: PropTypes.object,
  secondForm: PropTypes.object
};

export default LoginOMBMessage;



/** WEBPACK FOOTER **
 ** ./src/components/authentication/login/LoginOMBMessage.js
 **/